var vskoInput = angular.module('vskoInput', []);

vskoInput.directive('vskoInput', [function () {
  var TYPES = ['color', 'date', 'datetime', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week'];

  return {
    restrict: 'E',
    template: require('./vsko-input.html'),
    required: ['ngModel'],
    scope: {
      type: '@',
      placeholder: '@',
      ngDisabled: '=?',
      ngRequired: '=?',
      ngModel: '=',
      ngMin: '=?',
      ngMax: '=?'
    },
    link: function($scope, element, attrs) {
      'use strict';

      $scope.getStyleClass = function() {
        var styles = [];
        if ($scope.type === 'date') {
          styles.push('datepicker');
        }
        return styles.join(' ');
      };
    }
  }
}]);
